export const getReferenceEvidenceFileId = (sourceRef) => {
    const match = /^reference:([^:]+):segment-\d+$/i.exec(String(sourceRef || '').trim());
    return match?.[1] || null;
};

const compactText = (value) => String(value || '').replace(/\s+/g, ' ').trim();

export const getEvidenceTargetRef = (evidence = {}) => (
    evidence.target_ref || evidence.source_ref || null
);

export const buildReferenceEvidenceLabel = ({
    evidence = {},
    sourceKind,
    referenceDocumentTitle,
    requirementId,
    contractDocumentTitle,
} = {}) => {
    const documentLabel = sourceKind === 'reference'
        ? compactText(referenceDocumentTitle) || 'Référentiel'
        : compactText(evidence.document_title || contractDocumentTitle) || 'Contrat';
    const location = compactText(
        evidence.location
        || evidence.section
        || evidence.article
        || (sourceKind === 'reference' ? requirementId : '')
    );
    const page = evidence.page ? `p. ${evidence.page}` : '';
    const suffix = [location, page && !location.toLowerCase().includes(page.toLowerCase()) ? page : '']
        .filter(Boolean)
        .join(', ');
    if (sourceKind === 'contract' && !evidence.document_title && /\s(?:·|\|)\s/.test(location)) {
        return suffix || documentLabel;
    }
    return suffix ? `${documentLabel} · ${suffix}` : documentLabel;
};
